export default {
    api: {
        // baseURL: 'http://192.168.15.37:3001/api'
        // baseURL: 'http://localhost:3001/api'
        // baseURL: 'http://192.168.15.37:3001/api'
        // baseURL: 'https://caju02.azurewebsites.net/api'
        baseURL: 'https://optiapi.azurewebsites.net/api'
    }
};
